<template>
  <div
    class="order-planner-calendar-timeline__event"
    :class="[
      { 'order-planner-calendar-timeline__event--assigned': eventData.isAssigned },
      { 'order-planner-calendar-timeline__event--first-available': eventData.isFirstAvailablePlanning },
      hasFlags ? `order-planner-calendar-timeline__event--flags-${flagCount}` : null,
    ]"
    :data-order-id="eventData.orderId"
  >
    <div
      v-if="eventData.isFirstAvailablePlanning"
      class="order-planner-calendar-timeline__event-badge order-planner-calendar-timeline__event-badge--first-available"
    >
      Pierwszy wolny
    </div>
    <div
      v-if="eventData.isAssigned"
      class="order-planner-calendar-timeline__event-badge"
    >
      {{ eventData.statusLabel }}
    </div>

    <div class="order-planner-calendar-timeline__event-time">
      {{ eventData.scheduledAtLabel }}
    </div>

    <div class="order-planner-calendar-timeline__event-title">
      {{ eventData.title }}
    </div>

    <div
      v-if="eventData.pickupAddressLabel || eventData.deliveryAddressLabel"
      class="order-planner-calendar-timeline__event-addresses"
    >
      <div class="order-planner-calendar-timeline__event-address-row">
        <feather-icon
          icon="ArrowUpCircleIcon"
          size="13"
          class="mr-25 flex-shrink-0 text-success"
        />
        <span>{{ eventData.pickupAddressLabel }}</span>
      </div>
      <div class="order-planner-calendar-timeline__event-address-row">
        <feather-icon
          icon="ArrowDownCircleIcon"
          size="13"
          class="mr-25 flex-shrink-0 text-danger"
        />
        <span>{{ eventData.deliveryAddressLabel }}</span>
      </div>
    </div>

    <div
      v-if="hasFlags"
      class="order-planner-calendar-timeline__event-flags"
    >
      <b-avatar
        v-if="eventData.returnTransport"
        :title="'Transport w obie strony'"
        size="18"
        variant="info"
        class="mr-25"
      >
        <feather-icon
          icon="RepeatIcon"
          size="12"
        />
      </b-avatar>
      <b-avatar
        v-if="eventData.prioritySignals"
        :title="'Przejazd na sygnalach uprzywilejowania'"
        size="18"
        variant="primary"
        class="mr-25"
      >
        <feather-icon
          icon="LoaderIcon"
          size="12"
        />
      </b-avatar>
      <b-avatar
        v-if="eventData.absolutePunctuality"
        :title="'Nie mozna sie spoznic'"
        size="18"
        variant="danger"
        class="mr-25"
      >
        <feather-icon
          icon="ClockIcon"
          size="12"
        />
      </b-avatar>
      <b-avatar
        v-if="eventData.infectious"
        :title="'Zakazny'"
        size="18"
        variant="warning"
        class="mr-25"
      >
        <feather-icon
          icon="AlertTriangleIcon"
          size="12"
        />
      </b-avatar>
      <b-avatar
        v-if="eventData.private"
        :title="'Prywatny'"
        size="18"
        variant="success"
        class="mr-25"
      >
        <feather-icon
          icon="DollarSignIcon"
          size="12"
        />
      </b-avatar>
    </div>

  </div>
</template>

<script>
import { defineComponent, computed } from '@vue/composition-api'
import FeatherIcon from '@core/components/feather-icon/FeatherIcon.vue'

export default defineComponent({
  name: 'PlannerTimelineEventCard',
  components: { FeatherIcon },
  props: { eventData: { type: Object, required: true } },
  setup(props) {
    const flagCount = computed(() => [
      props.eventData.returnTransport,
      props.eventData.prioritySignals,
      props.eventData.absolutePunctuality,
      props.eventData.infectious,
      props.eventData.private,
    ].filter(Boolean).length)

    const hasFlags = computed(() => flagCount.value > 0)

    return { flagCount, hasFlags }
  },
})
</script>
